import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default function uspsAnimation() {
    gsap.registerPlugin(ScrollTrigger);

    const isSmall = Foundation.MediaQuery.upTo('xxxxlarge');
    const $wrapper = isSmall ? $('.usp-reveal-inner') : $('.usps-animated');
    const $section = $('.usp-reveal-inner');
    const $usps = $('.usp');
    const $images = $('.usp-images .image');
    const $progressLine = $('.progress-line');
    const $uspContainer = $wrapper.find('.usp-usps');

    if (!$section.length || !$usps.length || !$progressLine.length || Foundation.MediaQuery.upTo('xlarge')) return;

    let titleOffsets = [];
    let firstOffset = 0;
    let progressSpan = 100;

    function measureTitles() {
        const totalHeight = $uspContainer.outerHeight();
        titleOffsets = $usps.map(function () {
            return totalHeight > 0 ? ($(this).position().top / totalHeight) * 100 : 0;
        }).get();
        firstOffset = titleOffsets[0];
        progressSpan = 100 - firstOffset;
    }

    function updateProgress(self) {
        const currentHeight = firstOffset + self.progress * progressSpan;
        $progressLine.css('height', `${currentHeight}%`);
        let activeIndex = 0;
        for (let i = 0; i < titleOffsets.length; i++) {
            if (currentHeight >= titleOffsets[i]) activeIndex = i;
        }
        $usps.removeClass('is-active').eq(activeIndex).addClass('is-active');
        $images.removeClass('active').eq(activeIndex).addClass('active');
    }

    measureTitles();
    ScrollTrigger.create({
        trigger: $wrapper.get(0),
        pin: $wrapper.get(0),
        start: isSmall ? 'top-=20 top' : 'top-=-100 top',
        end: `+=${$usps.length * 300}`,
        scrub: true,
        onRefresh: self => {
            measureTitles();
            updateProgress(self);
        },
        onUpdate: updateProgress
    });

    let refreshFrame = null;
    function scheduleRefresh() {
        if (refreshFrame !== null) return;
        refreshFrame = requestAnimationFrame(() => {
            refreshFrame = null;
            ScrollTrigger.refresh();
        });
    }

    // Only observe preceding sections: the pin's own spacing must not cause a loop.
    const section = $section.closest('.usps-animated').get(0);
    if (typeof ResizeObserver !== 'undefined') {
        const heights = new Map();
        const observer = new ResizeObserver(entries => {
            let changed = false;
            for (const entry of entries) {
                const height = entry.contentRect.height;
                if (heights.has(entry.target) && Math.abs(height - heights.get(entry.target)) > 0.5) {
                    changed = true;
                }
                heights.set(entry.target, height);
            }
            if (changed) scheduleRefresh();
        });
        document.querySelectorAll('section').forEach(element => {
            if (section.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING) {
                observer.observe(element);
            }
        });
    }
    if (document.fonts) document.fonts.ready.then(scheduleRefresh);
    window.addEventListener('load', scheduleRefresh, { once: true });
}
